import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'GET_ALL_ARTICLES_USERTYPE':
			return {
				...state,
				entities: action.payload,
			}

		default:
			state = crudHandlers(state, action, 'article')

			return state
	}
}
